import { render } from "./AchievementRequest.vue?vue&type=template&id=28c35718"
import script from "./AchievementRequest.vue?vue&type=script&lang=js"
export * from "./AchievementRequest.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__